import script from "./StudentWorkerView.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentWorkerView.vue?vue&type=script&setup=true&lang=js"

import "./StudentWorkerView.vue?vue&type=style&index=0&id=47ab1050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ab1050"]])

export default __exports__